import { Component, OnDestroy, OnInit, SimpleChanges, Input, OnChanges } from '@angular/core';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';

@Component({
    selector: '[employee]',
    styleUrls: ['./employee.style.scss'],
    templateUrl: 'employee.template.html'
})
export class EmployeeComponent implements OnDestroy, OnInit {
    @Input() private employee: IDtoEmployee;
    @Input() private module: string;
    constructor () {       
    }
    ngOnInit(): void {
    }
    ngOnDestroy(): void {
    }
}
